import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { useAuthentication } from '../../LoginPage';
import React, { useState, useEffect } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { BusinessAndPeopleApi } from '@apply/api';
import { stateSelectorValues, alertModal, countyList } from '@apply/ui';
import DateBox from 'devextreme-react/date-box';

interface IEditLicenseToBuildModal {
    isOpen: boolean;
    onCloseCallback?: () => void;
    applicationInsights: ApplicationInsights;
    selectedBusinessId: any;
    builderLicenseId: any;
}
export const EditLicenseToBuildModal: React.FC<IEditLicenseToBuildModal> = (props) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(props.applicationInsights);

    const { authentication, isFeatureEnabled } = useAuthentication();
    const [validation, set_validation] = useState(undefined);
    const [loadingMessage, set_loadingMessage] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [saveEnabled, set_saveEnabled] = useState(false);

    const [licenseCountySelectList, set_licenseCountySelectList] = useState<{ value: string; display: string }[]>([]);

    const [license, set_license] = useState(null);
    const [canContinue, set_canContinue] = useState(true);

    const [businessId, set_businessId] = useState<number>(0);

    const [licenseBusinessName, set_licenseBusinessName] = useState<string>('');
    const [licenseFirstName, set_licenseFirstName] = useState<string>('');
    const [licenseLastName, set_licenseLastName] = useState<string>('');
    const [licenseNumber, set_licenseNumber] = useState<string>('');
    const [licenseState, set_licenseState] = useState<string>('');
    const [licenseCounty, set_licenseCounty] = useState<string>('');
    const [licenseExpirationDate, set_licenseExpirationDate] = useState<Date>();

    useEffect(() => {
        set_businessId(props.selectedBusinessId);
    }, [props.selectedBusinessId]);

    useEffect(() => {
        const tempCountyList = countyList
            .filter((county) => county.state === licenseState)
            .map((county) => {
                return { display: county.county, value: county.county };
            });
        tempCountyList.unshift({ display: '', value: '' });
        set_licenseCountySelectList(tempCountyList);
    }, [licenseState]);

    const loadDetails = async (id: number) => {
        // set_loadingMessage("Loading...");
        // set_loadingOpen(true);
        // const response = await businessAndPeopleApi.getLicenseToBuild(id);
        // if (!response || response.statusCode !== 200) {
        //   return;
        // }
        // set_license(response.result);
    };

    useEffect(() => {
        async function builderLicenseIdChanged() {
            resetState();
            if (!props.builderLicenseId || props.builderLicenseId <= 0) {
                set_license(null);
                return;
            }

            await loadDetails(props.builderLicenseId);
            set_loadingOpen(false);
        }

        builderLicenseIdChanged();
    }, [props.builderLicenseId]);

    useEffect(() => {
        setState(license);
    }, [license]);

    useEffect(() => {
        let fieldsValid = false;

        fieldsValid =
            licenseFirstName !== '' &&
            licenseLastName !== '' &&
            licenseState !== '' &&
            licenseNumber !== '' &&
            licenseExpirationDate !== undefined;

        set_canContinue(fieldsValid);
    }, [licenseFirstName, licenseLastName, licenseState, licenseNumber, licenseExpirationDate]);

    const setState = (license: any) => {
        if (!license) {
            return;
        }

        set_licenseBusinessName(license.businessName);
        set_licenseFirstName(license.firstName);
        set_licenseLastName(license.lastName);
        set_licenseNumber(license.licenseNumber);
        set_licenseState(license.licenseState);
        set_licenseCounty(license.licenseCounty);
        set_licenseExpirationDate(license.licenseExpirationDate);
    };

    const resetState = () => {
        set_businessId(0);
        set_licenseBusinessName('');
        set_licenseFirstName('');
        set_licenseLastName('');
        set_licenseNumber('');
        set_licenseState('');
        set_licenseCounty('');
        set_licenseExpirationDate(undefined);
    };

    const getSuccessMessage = (id: number) => {
        if (id === 0) {
            return 'Your License To Build was added successfully.';
        } else {
            return 'Your License To Build was updated successfully';
        }
    };

    const getGeneralErrorMessage = () => {
        return 'An error has occurred while communicating with our server.  Please try your operation again.';
    };

    const handleClose = () => {
        set_license(null);
        set_validation(undefined);
        resetState();
        props.onCloseCallback(null);
    };

    const cancelLicenseToBuild = () => {
        set_license(null);
        set_validation(undefined);
        resetState();
        props.onCloseCallback(null);
    };

    const validateLicenseToBuild = async () => {
        // //Check should validate whether the license to build already exists in the system / business - confirm requirements
        // set_loadingMessage("Validating...");
        // set_loadingOpen(true);
        // set_validation(undefined);
        // try {
        //   const model = {
        //     businessId,
        //     licenseNumber,
        //     licenseState,
        //     licenseCounty
        //   };
        //   const response = await businessAndPeopleApi.validateLicenseToBuild(model);
        //   if (response.statusCode !== 200 || !response.result) {
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   if (response.result.hasErrors || response.result.hasWarnings) {
        //     set_validation(response.result);
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   return true;
        // } catch (ex) {
        //   set_loadingOpen(false);
        //   set_validation(undefined);
        //   alertModal({
        //     message:
        //       getGeneralErrorMessage(),
        //   });
        //   return false;
        // }
    };

    const saveLicenseToBuild = async () => {
        // try {
        //     const isValid = await validateLicenseToBuild();
        //     if (!isValid) {
        //         return;
        //     }
        //     const model = {
        //         builderLicenseId: props.builderLicenseId ?? 0,
        //         businessId: props.selectedBusinessId ?? 0,
        //         licenseBusinessName,
        //         licenseFirstName,
        //         licenseLastName,
        //         licenseNumber,
        //         licenseExpirationDate,
        //         licenseState,
        //         licenseCounty
        //     };
        //     const response = await businessAndPeopleApi.saveLicenseToBuild(model);
        //     if (response.statusCode !== 200 || !response.result) {
        //         set_loadingOpen(false);
        //         alert(response.errors[0]);
        //         return false;
        //     }
        //     set_loadingOpen(false);
        //     alertModal({
        //         title: 'Success',
        //         message: getSuccessMessage(model.builderLicenseId),
        //         onConfirm: () => {
        //             handleClose();
        //         },
        //     });
        // } catch (ex) {
        //     set_loadingOpen(false);
        //     set_validation(undefined);
        //     alertModal({
        //         message: getGeneralErrorMessage(),
        //     });
        //     return false;
        // }
    };

    return (
        <div>
            <Dialog
                open={props.isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='md'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            role='dialog'
                            style={{ width: '500px', maxWidth: '80vw' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>
                                        {!props.builderLicenseId && props.builderLicenseId === 0
                                            ? 'Add License To Build'
                                            : 'Edit License To Build'}
                                    </h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='modal-content'>
                                    <div className='modal-body'>
                                        <div
                                            className='standard-form'
                                            style={{
                                                padding: 0,
                                            }}
                                        >
                                            <div
                                                className='scrollable-content'
                                                style={{ margin: '10px' }}
                                            >
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='licenseBusinessName'>
                                                            Business Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The name of the Business this license is issued to.
                                                            </span>
                                                        </span>
                                                        <input
                                                            type='text'
                                                            id='licenseBusinessName'
                                                            value={licenseBusinessName}
                                                            onChange={(e) => set_licenseBusinessName(e.target.value)}
                                                            required={true}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='licenseFirstName'>
                                                            First Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            id='licenseFirstName'
                                                            value={licenseFirstName}
                                                            onChange={(e) => set_licenseFirstName(e.target.value)}
                                                            required={true}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='licenseLastName'>
                                                            Last Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            id='licenseLastName'
                                                            value={licenseLastName}
                                                            onChange={(e) => set_licenseLastName(e.target.value)}
                                                            required={true}
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-7'>
                                                        <label htmlFor='licenseNumber'>
                                                            License Number<span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The license number for the license to build.
                                                            </span>
                                                        </span>
                                                        <input
                                                            id='licenseNumber'
                                                            type='text'
                                                            required={true}
                                                            value={licenseNumber}
                                                            onChange={(event) => set_licenseNumber(event.target.value)}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-5'>
                                                        <label htmlFor={'licenseExpirationDate'}>
                                                            Expiration Date<span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The expiration date of the license to build.
                                                            </span>
                                                        </span>
                                                        <DateBox
                                                            id='licenseExpirationDate'
                                                            value={licenseExpirationDate}
                                                            onValueChange={set_licenseExpirationDate}
                                                            type='date'
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor='licenseState'>
                                                            License State<span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The issuing state of the license to build.
                                                            </span>
                                                        </span>
                                                        <select
                                                            id={'licenseState'}
                                                            value={licenseState ?? ''}
                                                            required={true}
                                                            onChange={(event) => set_licenseState(event.target.value)}
                                                        >
                                                            {stateSelectorValues.map((v, i) => {
                                                                return (
                                                                    <option
                                                                        key={i}
                                                                        value={v.value}
                                                                    >
                                                                        {v.display}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className='columns small-12 large-6'>
                                                        <label htmlFor={'licenseCounty'}>License County</label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                The issuing county of the license to build.
                                                            </span>
                                                        </span>
                                                        <select
                                                            id={'licenseCounty'}
                                                            value={licenseCounty ?? ''}
                                                            onChange={(event) => set_licenseCounty(event.target.value)}
                                                        >
                                                            {licenseCountySelectList.map((v, i) => {
                                                                return (
                                                                    <option
                                                                        key={i}
                                                                        value={v.value}
                                                                    >
                                                                        {v.display}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal-content-actions'>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{
                                                        width: 150,
                                                    }}
                                                    onClick={cancelLicenseToBuild}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={{
                                                        width: 150,
                                                    }}
                                                    onClick={saveLicenseToBuild}
                                                    disabled={!canContinue || !saveEnabled}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </div>
    );
};
